<template>
    <section>
        <ValidationObserver class="columns" ref="observer">
            <div class="column">
                <ValidationProvider :rules="{ start_date_before_end_date: maxYear, required: true }"
                    v-slot="{ errors, failedRules }">
                    <b-field label="Año desde: *" 
                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                        <multiselect v-model="minYear" :options="year_options" :searchable="true" :close-on-select="true" :allow-empty="true"
                            selectLabel="Presione para seleccionar" selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                            placeholder="Elija un año" />
                    </b-field>
                </ValidationProvider>
            </div>

            <div class="column">
                <ValidationProvider :rules="{ end_date_not_before_start_date: minYear, required: true }"
                    v-slot="{ errors, failedRules }">
                    <b-field label="Año hasta: *" 
                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                        <multiselect v-model="maxYear" :options="year_options" :searchable="true" :close-on-select="true" :allow-empty="true"
                            selectLabel="Presione para seleccionar" selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                            placeholder="Elija un año" />
                    </b-field>
                </ValidationProvider>
            </div>

            <div class="column is-narrow">
                <br>
                <b-field label=" ">
                    <b-button icon-left="search" type="is-info" label="Aplicar Filtro" @click="check()" />
                </b-field>
            </div>
        </ValidationObserver>

        <b-tabs position="is-centered" v-model="currentTab" :multiline="true">
            <b-tab-item v-for="item in items" v-bind:key="item.content" :value="item.content" :label="item.tab"
                :disabled="item.disabled" :icon="item.icon" />
        </b-tabs>
        <!-- COMPONENTE AQUI -->
        <keep-alive>
            <component v-bind:is="currentTabComponent" :person-id="personId" :cargo-principal="cargoPrincipal"
                :min-year="minYear" :max-year="maxYear" :change-filter="changeFilter" :hide-update="true"
                :can-create-document="canCreateDocument" :can_create_award="can_create_award"
                :can_create_scholarship="can_create_scholarship" :principalUnitId="principalUnitId"
                :can_create_related_institution="can_create_related_institution"
                :canCreateMyVimeActivity="canCreateMyVimeActivity"
                :canCreateMyVimeAgreement="canCreateMyVimeAgreement" />
        </keep-alive>

        <!-- FIN COMPONENTE -->
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import MyVimeResumes from './my_vime_resume_tab.vue'
import MyVimeActivities from './my_vime_activities_tab.vue'
import MyVimeAgreements from './my_vime_agreements_tab.vue'
import MyScholarShips from './my_scholarships_data_tab.vue'
import MyRecognitions from './my_recognitions_tab.vue'
import MyRelatedInstitutions from './my_related_institutions_tab.vue'
export default {
    components:{
        MyVimeResumes, MyVimeActivities, MyVimeAgreements, MyScholarShips, MyRecognitions, MyRelatedInstitutions,
    },
    props:[
        'personId','photoUrl', 'cargoPrincipal', 'canCreateDocument', 'can_create_award',
        'can_create_scholarship', 'can_create_related_institution', 'principalUnitId', 'canCreateMyVimeActivity', 'canCreateMyVimeAgreement'
    ],
    data() {
        return {
            isLoading:false,
            currentTab: 'MyScholarShips',
            items: [
                {tab: 'Actividades',content: 'MyVimeActivities', icon:"calendar", disabled: true},
                {tab: 'Convenios',content: 'MyVimeAgreements', icon:"handshake", disabled: true},
                {tab: 'Becas',content: 'MyScholarShips', icon:"school", disabled: false},
                {tab: 'Reconocimientos',content: 'MyRecognitions', icon:"award", disabled: false},
                {tab: 'Afiliaciones',content: 'MyRelatedInstitutions', icon:"industry", disabled: false},
                {tab: 'Curriculum VIME I+D',content: 'MyVimeResumes', icon:"file-contract", disabled: false},
            ],
            minYear:new Date().getFullYear() - 5,
            maxYear:new Date().getFullYear(),
            year_options:Array.from({length:(new Date().getFullYear()-2000+1)},(v,k)=>k+2000).reverse(),
            changeFilter: false,
        }
    },
    methods: {
        changeTab: function(value){
            this.currentTab = value
        },
        async check() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Los campos del Filtro de Años tienen errores.', 
                    type: 'is-danger',
                    hasIcon: true, 
                    icon: 'times-circle', 
                    iconPack: 'fa', 
                    ariaRole: 'alertdialog', 
                    ariaModal: true
                })
            } else {
                this.changeFilter = !this.changeFilter
            }
        }
    },
    computed: {
        currentTabComponent: function () {
            return this.currentTab
        }
    }
}
</script>